<template>
  <naj-box :title="`${titles.title} ( ${partyTypeRole} )`">
    <v-row>
      <v-col
        v-if="!allowCommercialRegistrationNumber"
        cols="8"
        lg="4"
      >
        <naj-input
          v-mask="'7#########'"
          :type-id="formFieldType.number"
          :label="titles.unifiedNumber"
          :value.sync="formModel.unifiedNumber"
          :validates="`required|long|isIdAllowed|isVerified:${isVerified}`"
          :disabled="isChecking || isViewMode"
          @input="commercialRegistrationNumberChanged"
        ></naj-input>
      </v-col>
      <v-col
        v-else
        cols="8"
        lg="4"
      >
        <naj-input
          :type-id="isCommercialRegistrationNumberOfTypeText ? formFieldType.text : formFieldType.number"
          :label="titles.commercialRegistrationNumber"
          :value.sync="formModel.commercialRegistrationNumber"
          :validates="`required${isCommercialRegistrationNumberOfTypeText ? '|english_letters_numbers' : '|long'}|isIdAllowed|isVerified:${isVerified}`"
          :disabled="isChecking || isViewMode"
          @input="commercialRegistrationNumberChanged"
        ></naj-input>
      </v-col>
      <v-col
        v-if="enableManagerSocialId && !isVerified"
        cols="4"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="titles.socialId"
          :value.sync="socialId"
          :validates="required?`required|isVerified:${isVerified}`:''"
          :disabled="isChecking"
          @input="commercialRegistrationNumberChanged"
        ></naj-input>
      </v-col>
      <v-col
        v-if="!isForeignCompany(formModel) && formModel.commercialRegistrationNumber"
        cols="4"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="titles.commercialRegistrationNumber"
          :value.sync="formModel.commercialRegistrationNumber"
          :disabled="validationRequired || isViewMode"
        ></naj-input>
      </v-col>
      <v-col
        v-if="formModel.commercialRegistrationTypeId != null && !isOrganizationOwner(formModel) && showCommercialRegistrationTypeId"
        cols="4"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="titles.commercialRegistrationTypeName"
          :value.sync="commercialRegistrationTypeName"
          :disabled="true"
        ></naj-input>
      </v-col>
      <v-col
        v-if="(validationRequired && !formModel.isRetrievedFromMci) || isChecking"
        class="d-flex align-center"
        cols="4"
        lg="2"
      >
        <naj-button
          square
          inputs-alignment
          :disabled="disableCheckButton"
          @click="check"
        >
          {{ local.personInformation.check }}
        </naj-button>
      </v-col>
      <v-col cols="12">
        <naj-input
          :type-id="formFieldType.text"
          :label="titles.name"
          :value.sync="formModel.name"
          :disabled="validationRequired || isViewMode"
          :validates="`required|max:200${isVerified ? '' : '|arabic'}`"
        ></naj-input>
      </v-col>
    </v-row>
    <v-row v-if="!isForeignCompany(formModel)">
      <v-col cols="12">
        <naj-input
          :type-id="formFieldType.textarea"
          :label="titles.activities"
          :value.sync="formModel.activity"
          :disabled="validationRequired || isViewMode"
          :validates="`${isVerified ? '' : 'arabic|'}max:${maxActivityLength}`"
        ></naj-input>
      </v-col>
    </v-row>
    <v-row
      v-if="isCompanyWithoutManager && isEditSubMode"
      :gutter="16"
    >
      <v-col
        cols="12"
        class="red--text"
      >
        {{ local.personInformation.commercialRegistrationNotVerified }}
      </v-col>
    </v-row>
  </naj-box>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { isForeignCompany, isOrganizationOwner } from '../../../../helpers/utils';
import { casePartyRoleByIdEnum, CRStatus } from '@/helpers/enum.js';
const { mapGetters } = createNamespacedHelpers('LawsuitModule');
const { mapActions: mapSysActions } = createNamespacedHelpers('SystemModule');
import { commercialRegistrationTypes } from '@/helpers/enum';

export default {
  inject: ['$validator'],
  props: {
    titles: { required: true },
    formModel: { required: true },
    validationRequired: { type: Boolean },
    required: { required: false },
    isCommercialRegistrationNumberOfTypeText: {
      type: Boolean,
      required: false,
      default: false,
    },
    isViewMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    enableManagerSocialId: {
      required: false,
      type: Boolean,
      default: false,
    },
    allowAddressCheck: {
      required: false,
      type: Boolean,
      default: false,
    },
    showCommercialRegistrationTypeId: {
      type: Boolean,
      default: false,
    },
    allowCommercialRegistrationNumber: {
      required: false,
      type: Boolean,
      default: false,
    },
    checkCommercialRegisterNumberStatus: {
      require: false,
      default: false,
      type: Boolean,
    },
    isJoinderRequest: {
      require: false,
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      isChecking: false,
      isCommercialRegistrationChecked: false,
      isForeignCompany,
      isOrganizationOwner,
      commercialRegistrationTypes,
      maxActivityLength: 20000,
      socialId: null,
    };
  },
  computed: {
    ...mapGetters(['isEditSubMode']),
    partyTypeRole() {
      var partyRoleValue = this.formModel.casePartyRole !== 0 ? this.formModel.casePartyRole : this.formModel.relatedPartiesInfo[0].casePartyRole;
      return (
        this.local.common.casePartyRoles[casePartyRoleByIdEnum[partyRoleValue]]
      );
    },
    isVerified() {
      return this.isCompanyWithoutManager || !this.validationRequired || this.formModel.isRetrievedFromMci;
    },
    isCompanyWithoutManager() {
      return (!!this.formModel.commercialRegistrationNumber
        && !!this.formModel.name
        && !this.formModel.isRetrievedFromMci);
    },
    showCommercialRegistrationNotVerifiedMsg() {
      return (
        !this.formModel.isRetrievedFromMci &&
        (this.isCommercialRegistrationChecked || this.isEditSubMode)
      );
    },
    disableCheckButton() {
      return this.isChecking || (!this.formModel.unifiedNumber || (this.enableManagerSocialId && this.required && !this.socialId)) || this.isViewMode;
    },
    commercialRegistrationTypeName() {
      return this.getCommercialRegistrationType(this.formModel.commercialRegistrationTypeId);
    },
  },
  watch: {
    enableManagerSocialId(value) {
      if (!value)
        this.socialId = null;
    },
    'formModel.unifiedNumber'(val) {
      if (!val)
        this.$set(this, 'socialId', null);
    },
  },
  mounted() {
    if (this.enableManagerSocialId)
      this.socialId = this.formModel.socialId;
  },
  methods: {
    ...mapSysActions(['checkCommercialRegistrationNumber']),
    getCommercialRegistrationType(commercialRegistrationTypeId) {
      if (commercialRegistrationTypeId == null) '';
      const type = this.commercialRegistrationTypes.find(c => c.id === commercialRegistrationTypeId);
      return type ? type.name : '';
    },
    check() {
      this.isChecking = true;
      const companyRequest = {
        commercialRegistrationNumber: this.formModel.unifiedNumber,
        socialId: this.socialId || ' ',
        partyType: this.formModel.partyType,
        allowAddressCheck: !!this.allowAddressCheck,
      };
      this.resetCompanyInfo();
      this.checkCommercialRegistrationNumber(companyRequest)
        .then((companyInfo) => {
          const status = companyInfo.response && companyInfo.response.status;
          if (status !== 400) {
            if (this.checkCommercialRegisterNumberStatus && companyInfo['statusId'] === CRStatus.cancelled) {
              this.$set(this.formModel, 'isRetrievedFromMci', false);
              this.toaster.error(this.local.organizationData.unifiedNumberCancelled);
              return;
            }
            if (companyInfo['commercialRegistrationTypeId'] === 1) {
              this.$set(this.formModel, 'isRetrievedFromMci', false);
              if (this.isJoinderRequest) {
                this.toaster.error(this.local.organizationData.prohibitedCommercialTypeForJoinderRequest);
                return;
              }
              this.toaster.error(this.local.organizationData.prohibitedCommercialType({
                unifiedNumber: companyInfo.mainCRUnifiedNumber != null ? ' ورقمه ' + companyInfo.mainCRUnifiedNumber : '',
                name: companyInfo.organizationName,
              }), 3000);

              return;
            }
            for (const key in companyInfo) {
              if (Object.prototype.hasOwnProperty.call(companyInfo, key)) {
                if (this.formModel.isRetrievedFromMci && companyInfo['activity'] && companyInfo['activity'].length > this.maxActivityLength)
                  companyInfo['activity'] = companyInfo['activity'].substr(0, 19996)
                    .concat(' ...');
                if (key == 'commercialRegistrationTypeId') {
                  this.formModel.commercialRegistrationTypeName = this.getCommercialRegistrationType(companyInfo[key]);
                }
                this.$set(this.formModel, key, companyInfo[key]);
              }
            }
          }
          else
            this.$set(this.formModel, 'isRetrievedFromMci', false);
        })
        .catch((error) => {
          const status = error.response && error.response.status;
          status == 404 && this.$Notice.error({
            title: this.local.organizationData.checkCommercialRegistrationNumberError,
            top: 50,
            duration: 5,
          });
          this.$set(this.formModel, 'isRetrievedFromMci', false);
        })
        .finally(() => {
          this.isChecking = false;
          this.isCommercialRegistrationChecked = true;
        });
    },
    commercialRegistrationNumberChanged() {
      this.resetCompanyInfo();
      this.isCommercialRegistrationChecked = false;
    },
    resetCompanyInfo() {
      this.$set(this.formModel, 'isRetrievedFromMci', false);
      this.$set(this.formModel, 'firstName', null);
      this.$set(this.formModel, 'fatherName', null);
      this.$set(this.formModel, 'grandFatherName', null);
      this.$set(this.formModel, 'familyName', '');
      this.$set(this.formModel, 'socialId', null);
      this.$set(this.formModel, 'nationalityCountryId', null);
      this.$set(this.formModel, 'socialIdType', null);
      this.$set(this.formModel, 'name', null);
      this.$set(this.formModel, 'activity', null);
      this.$set(this.formModel, 'commercialRegistrationTypeId', null);
      !this.allowCommercialRegistrationNumber && this.$set(this.formModel, 'commercialRegistrationNumber', null);
    },
  },
};
</script>
